import React from 'react';
import type { PapiDeviation } from '@wix/da-papi-types';
import HiddenIcon from '@wix/da-ds/pkg/Icons/32x32/Hidden';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

interface Props {
  deviation: PapiDeviation;
  thumbWidth?: number;
  thumbHeight?: number;
  className?: string;
}

/** overlays text to explain mature/nsfg block reasons */
const ContentFilterMiddleContent: React.FC<Props> = ({ className }) => {
  return (
    <HoverOnly reverseHidden>
      <div className={className}>
        <HiddenIcon size={IconSize.LARGE} disableDefaultColors />
      </div>
    </HoverOnly>
  );
};
ContentFilterMiddleContent.displayName = 'ContentFilterMiddleContent';

export default ContentFilterMiddleContent;
